import styled, { css } from "styled-components";

export const Input = styled.input`
  background-color: white;
  border: 2px solid ${({ theme }) => theme.colors.gray[600]};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.gray[700]};
  font-size: 15px;
  height: 42px;

  letter-spacing: 0;
  line-height: 20px;
  outline: none;
  padding: 0 8px;
  width: 100%;
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray[600]};
  }
  ${({ readOnly }) =>
    readOnly &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.gray[500]};
      color: ${({ theme }) => theme.colors.gray[700]};
      cursor: not-allowed;
    `}
`;
